import { ILocation } from '../model/location';



export const LOCATIONS: ILocation[] = [

  { id: '1', name: 'Köln Nippes', city: 'Beschreibung', address: 'Beschreibung', firstPossibleAppointment: 'datum'},
  { id: '2', name: 'Köln Mülheim', city: 'Beschreibung',address: 'Beschreibung', firstPossibleAppointment: 'datum'}
];
